import React from "react";
import NavigationBar from "../../../components/navbar/NavigationBar";
import Hero from "../Hero/Hero";
import styles from "./Home.module.css";
import Features from "../Features/Features";
import Pricing from "../Pricing/Pricing";

function Home() {
    return (
        <>
            <NavigationBar />
            <Hero />

            <div className={styles["features-pricing-container"]}>
                <Features />
                <Pricing />
            </div>
        </>
    )
}

export default Home;